import HistoryDetail from "../organisms/HistoryDetail";
import unescapeHtmlTag from "../../../../../core/utils/tools";

const Monthly = ({closeModal, closeSubModal, componentMount, subModalMount, items, formattedDate, truncateText, formatDateTime}) => {

  const modalProps = { subModalMount, closeModal, closeSubModal };

  return (
    <div className={"monthly"}>
      <h2>{formattedDate}</h2>
      <ul>
        {items.map(item => {
          return (
            <li key={item.id + item.createdAt} onClick={() => componentMount(
              <HistoryDetail
                item={item}
                date={formatDateTime(item.createdAt)}
                {...modalProps}
              />)
            }>
              <div className={"thumbnail"}>
                {/*<img src={`${process.env.REACT_APP_image_path}/images/${item.extImage}` || ""} alt={""}/>*/}
                <img src={item.extImage} alt={""}/>
              </div>
              <div className={"contents"}>
                <div className={"title"}>{unescapeHtmlTag(item.title)}</div>
                {/*<div className={"product-name"}>{`${item.displayTitle} ${item.displaySubtitle}`}</div>*/}
                <div className={"desc ellipsis-text"}>{truncateText(unescapeHtmlTag(item.description), 500)}</div>
                <div className={"createdAt"}>{formatDateTime(item.createdAt)}</div>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Monthly;
